/**
 * Simple utility to detect OS and Device Type for forensic logging.
 */
export const getDeviceInfo = () => {
  const ua = window.navigator.userAgent;

  // OS Detection
  let os = 'Unknown OS';
  if (ua.indexOf('Win') !== -1) os = 'Windows';
  if (ua.indexOf('Mac') !== -1) os = 'macOS';
  if (ua.indexOf('X11') !== -1) os = 'UNIX';
  if (ua.indexOf('Linux') !== -1) os = 'Linux';
  if (/Android/.test(ua)) os = 'Android';
  if (/iPhone|iPad|iPod/.test(ua)) os = 'iOS';

  // Device Type Detection
  let deviceType = 'Desktop';
  if (/Mobi|Android|iPhone/i.test(ua)) {
    deviceType = 'Mobile';
  } else if (/Tablet|iPad/i.test(ua)) {
    deviceType = 'Tablet';
  }

  return {
    os,
    deviceType,
    userAgent: ua,
  };
};
